import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import styles from './EmployerPortalJobList.module.css';
import EmployerPortalJobs from '../EmployerPortalJobs/EmployerPortalJobs';
import EmployerPortalJobDetail from '../EmployerPortalJobDetail/EmployerPortalJobDetail';
import { getBestMatches, getJobsList, } from '../../../../services/jobService';
import { useLocation, useParams } from 'react-router-dom';

function EmployerPortalJobList({ setPostJobEnable }) {
    const [page, setPage] = useState(1);
    const [jobs, setJobs] = useState([]);
    const user = useSelector(state => state.user.user);
    const [selectedJobsForDetail, setSelectedJobsForDetail] = useState('');
    const [similarJobs, setsimilarJobs] = useState([])
    const location = useLocation();
    const { id } = useParams();

    // const yourData = location.state?.yourData;

    useEffect(() => {
        getJobsList(page, 1000, null, { employer_id: user.id }, user.employer_status || user.jobseeker_status)
            .then((response) => { setJobs(response) })
            .catch((error) => { console.error('Failed to fetch jobs after retries:', error); });
    }, [user, selectedJobsForDetail])
    useEffect(() => {
        const getBestMatch = async () => {
            const jobId = jobs?.jobs?.filter((e) => e.id == selectedJobsForDetail)[0]?.id
            await setsimilarJobs(await getBestMatches(jobId))
        }
        if (selectedJobsForDetail && jobs?.jobs?.length > 0) getBestMatch()
    }, [selectedJobsForDetail, jobs])

    useEffect(() => {
        if (location.pathname == '/employer-portal/' + id) {
            if (jobs) {
                setSelectedJobsForDetail(Number(id))
            }
        }
    }, [location, jobs])
    return (
        <div className={styles.container}>
            {!selectedJobsForDetail ?
                <EmployerPortalJobs
                    jobs={jobs}
                    setPostJobEnable={setPostJobEnable}
                    setSelectedJobsForDetail={setSelectedJobsForDetail}
                />
                :
                jobs?.jobs?.filter((e) => e.id == selectedJobsForDetail).length > 0 &&
                <EmployerPortalJobDetail
                    setSelectedJobsForDetail={setSelectedJobsForDetail}
                    jobs={jobs}
                    setJobs={setJobs}
                    similarJobs={similarJobs}
                    jobDetail={jobs?.jobs?.filter((e) => e.id == selectedJobsForDetail)[0]}
                />

            }
        </div>
    );
}

export default EmployerPortalJobList;






